/* eslint-disable @angular-eslint/prefer-standalone */
// eslint-disable-next-line @typescript-eslint/naming-convention
import {
  AfterViewInit,
  Component,
  Input,
  SimpleChanges,
  OnChanges,
  input,
  ElementRef,
  Renderer2,
  effect
} from '@angular/core';
import { PdfPreviewService } from './pdf-preview.service';

@Component({
  selector: 'app-content-preview',
  templateUrl: './content-preview.component.html',
  styleUrls: ['./content-preview.component.scss'],
  standalone: false
})
export class ContentPreviewComponent implements AfterViewInit, OnChanges {
  @Input() public set token(value: string) {
    if (!value) return;
    this._token = value;
  }
  @Input() public fileId: string;
  @Input() public id = '';

  /**
   * height in pixels
   *
   * @example
   *
   * ```html
   * <app-content-preview
   *  [fileId]="selectedFile.id"
   *  [height]="200"
   * />
   * ```
   */
  public height = input<number>();
  public width = input<number | string>('100%');

  private _token: string;

  public constructor(
    private _pdfPreviewService: PdfPreviewService,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    effect(() => {
      if (this.width()) {
        this.renderer.setStyle(this.el.nativeElement, 'width', this.width());
      }
    });
  }

  public ngAfterViewInit(): void {
    this.setPreview();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.fileId && !changes.fileId.firstChange) {
      this.setPreview();
    }
  }

  private setPreview(): void {
    this._pdfPreviewService.showPreview(this.fileId, this._token, {
      container: '#my-box-content-preview-' + this.fileId + this.id,
      showDownload: true,
      showAnnotations: false,
      logoUrl:
        'https://assets-global.website-files.com/651b17ebe9db010c53be05ab/6544387fe5ec89904563083e_sustainment-logo2%201.svg'
    });
  }
}

export class Preview {
  public hide: () => void;
  public show: (
    fileId: string,
    accessToken: string,
    options: ContentPreviewOpts
  ) => void;
  public print: () => void;
  public download: () => void;
  public addListener: () => void;
}
interface ContentPreviewOpts {
  container: string;
  showDownload: boolean;
  showAnnotations: boolean;
  logoUrl: string;
  view: { zoom: number };
}
